// extracted by mini-css-extract-plugin
export var quantityInput = "_g6-0";